/* eslint-disable react/jsx-handler-names */
import { goToErrorsView } from 'actions/errorViewNavigation';

require('./openCreditSale.scss');

// @ vendors
const React = require('react');
const { bindActionCreators } = require('redux');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');
const classnames = require('classnames');
const cryptoJS = require('crypto-js');
// @actions
import cardImagesActions from 'actions/cardImagesActions';
import productsActions from 'actions/productsActions';
import configCardActions from 'actions/configCardActions';
import preLoaderActions from 'actions/preLoaderActions';
const formActions = require('react-redux-form').actions;
// @ components
import CreditCardOffer from 'components/creditCardOffer/creditCardOffer';
import CreditCardOfferInfoModal from 'components/creditCardOfferInfoModal/creditCardOfferInfoModal';
import CreditCardInePDF from 'components/CreditCardComponents/CreditCardInePDF/CreditCardInePDF';
import CreditCardLimitCredit from 'components/CreditCardComponents/CreditCardLimitCredit/CreditCardLimitCredit';
import { InfoTooltip } from 'components/tooltip/tooltip';
// @ utilities
import { FormattedText } from 'core/i18n';
import { recordEvent, errorTag, PAGE_PRODUCT } from 'utilities/uTagging';
// @ constants
import arrowIcon from 'assets/icons/icon-arrow.svg';
import { ERROR_AL_CONFIGURAR_TARJETA_DE_CREDITO } from 'constants/analyticsErrors';

class OpenCreditSale extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showCreditCardInfoModal: false,
        };

        this.handleCreditCardOfferingChange = this.handleCreditCardOfferingChange.bind(this);
        this.handleCreditCardInfoModalVisibility = this.handleCreditCardInfoModalVisibility.bind(this);
        this.handlePaymentSave = this.handlePaymentSave.bind(this);
        this.triggerEvent = this.triggerEvent.bind(this);
        this.triggerLink = this.triggerLink.bind(this);
    }

    UNSAFE_componentWillMount() {
        const { cardImages, cardImagesActions, userProfile } = this.props;

        if (!cardImages.get('cardImagesArray').size) {
            cardImagesActions.getCreditCardImageAction();
        }

        if (userProfile.creditCardOffer_accepted) {
            this.handlePaymentSave();
        }
    }

    async componentDidMount() {
        const { preLoaderActions, handleDisableNextButton } = this.props;
        const precontractual = document.getElementById('precontractual');

        if (precontractual) {
            precontractual.addEventListener('click', this.triggerLink);
        }

        try {
            await this.setOpenCreditInitialProps();
            handleDisableNextButton(true);
        } catch (e) {
            return e;
        }

        preLoaderActions.hidePreLoader();
    }

    setOpenCreditInitialProps = async () => {
        const {
            configCardActions,
            userProfile: { accessToken },
        } = this.props;

        try {
            const openCreditPdf = await configCardActions.getOpenCreditPDF(accessToken);

            this.setState({
                openCreditPdf: `data:application/pdf;base64,${openCreditPdf}`,
            });
        } catch (e) {
            return e;
        }
    };

    handleCreditCardOfferingChange(checked) {
        const { userProfile, productsActions, formActions } = this.props;
        const accessToken = userProfile.accessToken;

        productsActions.clearProductsInfo();
        productsActions.getOrDeleteCreditCard(checked, accessToken);

        if (checked) {
            this.handlePaymentSave();
        } else {
            formActions.change('userProfile.creditCard', '');
            formActions.change('userProfile.paymentMethodType', '');
        }
    }

    handleCreditCardInfoModalVisibility() {
        const { tagPath, userProfile } = this.props;
        const { docNumber } = userProfile;
        const docNumberEncrypted = docNumber ? cryptoJS.SHA256(docNumber).toString() : '';
        this.setState(
            prevState => ({
                showCreditCardInfoModal: !prevState.showCreditCardInfoModal,
            }),
            () => {
                if (this.state.showCreditCardInfoModal) {
                    recordEvent(
                        tagPath,
                        PAGE_PRODUCT,
                        'modal mas información tarjeta de crédito',
                        'modal mas información tarjeta de crédito desplegado',
                        '',
                        '',
                        '',
                        userProfile.investmentType,
                        docNumberEncrypted
                    );
                }
            }
        );
    }

    handleSuccessModal = () => {
        this.handleCreditCardOfferingChange(true);
        this.props.formActions.change('userProfile.creditCardOffer_accepted', true);
        this.handleCreditCardInfoModalVisibility();
    };

    handlePaymentSave(value) {
        const { userProfile, configCardActions, goToErrorsView } = this.props;
        const data = value;
        const accessToken = userProfile.accessToken;

        if (userProfile.creditCard && value) {
            const cardConfigId = userProfile.creditCard.id;
            configCardActions.updateCredit(cardConfigId, data, accessToken, (saved, errors) => {
                if (!saved) {
                    if (errors['6002']) {
                        goToErrorsView({ errorCode: 6002 });
                    }
                }
            });
        } else if (!userProfile.creditCard) {
            const defaultData = {};
            defaultData['cardDesignId'] = userProfile.openCreditCardSelectedId
                ? userProfile.openCreditCardSelectedId
                : 1;
            defaultData['installmentAmount'] = userProfile.fixedPaymentMethodValue
                ? userProfile.fixedPaymentMethodValue
                : 0;
            defaultData['paymentType'] = userProfile.paymentType ? userProfile.paymentType : '';
            defaultData['percentage'] = userProfile.percentage ? userProfile.percentage : 0;

            configCardActions.saveCredit(defaultData, accessToken, (saved, error) => {
                if (!saved) {
                    errorTag(error.body, PAGE_PRODUCT, ERROR_AL_CONFIGURAR_TARJETA_DE_CREDITO, error.statusCode);
                    goToErrorsView({
                        errorCode: error.statusCode,
                        errorMessage: ERROR_AL_CONFIGURAR_TARJETA_DE_CREDITO,
                    });
                }
            });
        }
    }

    getImageUrl() {
        const { cardImages } = this.props;
        let url;

        cardImages.get('cardImagesArray').map((item, index) => {
            if (index === 0) {
                url = item.get('url');

                return;
            }
        });

        return url;
    }

    getLimit() {
        const { showLimit, limit } = this.props;
        let limitBlock = null;

        if (showLimit) {
            limitBlock = <CreditCardLimitCredit limit={limit} />;
        }

        return limitBlock;
    }

    triggerLink() {
        const { tagPath, userProfile } = this.props;
        const { docNumber } = userProfile;
        const docNumberEncrypted = docNumber ? cryptoJS.SHA256(docNumber).toString() : '';

        recordEvent(
            tagPath,
            PAGE_PRODUCT,
            'precontractual tarjeta de crédito',
            'precontractual tarjeta de crédito desplegado',
            '',
            '',
            '',
            userProfile.investmentType,
            docNumberEncrypted
        );
    }

    buildCreditCardOffering() {
        const { products, userProfile } = this.props;
        const precontractual = products.get('creditCardPrecontractual')
            ? products.get('creditCardPrecontractual')
            : null;
        const label = <FormattedText value="creditCardOffer-hire" />;
        const subLabel = <FormattedText value="creditCardOffer-precontractual" injectedStrings={[precontractual]} />;
        const disabled = this.props.immStepsState.get('readOnlyForms');

        return (
            <div className="persona-data-view open-credit-sale__checkbox-container">
                <CreditCardOffer
                    label={label}
                    onChange={this.handleCreditCardOfferingChange}
                    subLabel={subLabel}
                    remarkable={false}
                    disabled={disabled}
                    {...this.props}
                />
                <CreditCardOfferInfoModal
                    show={this.state.showCreditCardInfoModal}
                    onClose={event => {
                        event.preventDefault();
                        this.handleCreditCardInfoModalVisibility();
                    }}
                    onSuccess={this.handleSuccessModal}
                    disabled={userProfile.creditCardOffer_accepted}
                />
            </div>
        );
    }

    getConfirmSection() {
        return (
            <section className="open-credit-sale__are-you-sure">
                <div className="row">
                    <div className="col-xs-12">
                        <i className="icons icons--icon-info-blue open-credit-sale__are-you-sure-icon"></i>
                        <div className="open-credit-sale__are-you-sure__block">
                            <div className="open-credit-sale__are-you-sure__block-title">
                                <FormattedText value="creditCardOffer-areYouSure" />
                            </div>
                            <div className="open-credit-sale__are-you-sure__block-subtitle">
                                <FormattedText value="creditCardOffer-areYouSureSubtitle" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    getTitle() {
        const { title } = this.props;

        return (
            <div className="row">
                <div className="col-xs-12">
                    <div className="open-credit-sale__title">{title}</div>
                </div>
            </div>
        );
    }

    triggerEvent() {
        const { tagPath, userProfile } = this.props;
        const { docNumber } = userProfile;
        const docNumberEncrypted = docNumber ? cryptoJS.SHA256(docNumber).toString() : '';

        recordEvent(
            tagPath,
            PAGE_PRODUCT,
            'tooltip tarjeta de crédito',
            'tooltip tarjeta de crédito desplegado',
            '',
            '',
            '',
            userProfile.investmentType,
            docNumberEncrypted
        );
    }

    render() {
        const { userProfile, title, CMSText, CMSTooltip, scorings } = this.props;
        const { openCreditPdf } = this.state;
        const imageCard = this.getImageUrl();
        const limit = this.getLimit();
        const areYouSure = !userProfile.creditCardOffer_accepted ? this.getConfirmSection() : null;
        const titleBlock = title ? this.getTitle() : null;
        const cardOffer = this.buildCreditCardOffering();
        const ML2_approved = scorings.getIn(['ml2', 'scoringStatus']) === 'approved';
        const openCreditClass = classnames('row open-credit-sale', {
            'open-credit-sale__background': ML2_approved,
            'open-credit-sale__bottom': !ML2_approved,
        });

        return (
            <React.Fragment>
                <section className={openCreditClass}>
                    <div className="persona-data-view">
                        {titleBlock}
                        <div className="col-xs-12 col-sm-4">
                            <img src={imageCard} className="open-credit-sale__img" />
                        </div>

                        <div className="col-xs-12 col-sm-8 open-credit-sale__padding">
                            {limit}
                            <div className="open-credit-sale__cms">
                                {CMSText}
                                <InfoTooltip
                                    text={CMSTooltip}
                                    newClassName="open-credit-sale-tooltip"
                                    triggerEvent={this.triggerEvent}
                                />

                                <div className="open-credit-sale__info-modal-link">
                                    <a
                                        className="credit-card-offer__label-link"
                                        href="#"
                                        onClick={event => {
                                            event.preventDefault();
                                            this.handleCreditCardInfoModalVisibility();
                                        }}
                                    >
                                        <FormattedText value="creditCardOffer-infoModalLinkIconLabel" />
                                        <img className="credit-card-offer__label-icon" src={arrowIcon} alt="" />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    {cardOffer}
                </section>
                <CreditCardInePDF
                    handleDisableNextButton={this.props.handleDisableNextButton}
                    pdfFile={openCreditPdf}
                    togglingCondition={true}
                />
                {areYouSure}
            </React.Fragment>
        );
    }
}

OpenCreditSale.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    showLimit: PropTypes.bool,
    limit: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    CMSText: PropTypes.any,
    CMSTooltip: PropTypes.any,
    tagPath: PropTypes.string,
    handleDisableNextButton: PropTypes.func.isRequired,
};

OpenCreditSale.defaultProps = {
    title: '',
    showLimit: true,
};

module.exports.constructor = OpenCreditSale;
module.exports.OpenCreditSale = connect(
    state => ({
        userProfile: state.userProfile,
        userProfileForm: state.userProfileForm,
        immStepsState: state.steps,
        cardImages: state.cardImages,
        products: state.products,
        scorings: state.scorings,
    }),
    dispatch => ({
        formActions: bindActionCreators(formActions, dispatch),
        cardImagesActions: bindActionCreators(cardImagesActions, dispatch),
        productsActions: bindActionCreators(productsActions, dispatch),
        configCardActions: bindActionCreators(configCardActions, dispatch),
        preLoaderActions: bindActionCreators(preLoaderActions, dispatch),
        goToErrorsView: bindActionCreators(goToErrorsView, dispatch),
    })
)(OpenCreditSale);
